import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { PersistGate } from 'redux-persist/integration/react';
import router from './Router';
import store, { persistor } from './store/store';
import { MuiTheme } from './configs/theme';
import MsalProvider from './contexts/MsalProvider';

function App() {
    return (
        <ThemeProvider theme={MuiTheme}>
            <Provider store={store} key={'scorm-redux-store'}>
                <PersistGate loading={null} persistor={persistor}>
                    <MsalProvider>
                        <RouterProvider router={router} />
                    </MsalProvider>
                </PersistGate>
            </Provider>
        </ThemeProvider>
    );
}

export default App;
